<template>
  <span class="scaling-svg-container">
    <svg
      class="scaling-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="11.501"
      height="14.376"
      viewBox="0 0 11.501 14.376"
    >
      <path
        d="M9.663,14.376H1.837A1.819,1.819,0,0,1,0,12.578V1.8A1.819,1.819,0,0,1,1.837,0H6.868A.722.722,0,0,1,7.4.236l3.913,4.313a.72.72,0,0,1,.187.483v7.546A1.82,1.82,0,0,1,9.663,14.376ZM1.837,1.437a.382.382,0,0,0-.4.36V12.578a.382.382,0,0,0,.4.36H9.663a.382.382,0,0,0,.4-.36V5.75H7.7A2,2,0,0,1,5.75,3.7V1.437Zm5.351.7V3.7a.569.569,0,0,0,.513.611H9.158ZM5.75,10.782a.72.72,0,0,1-.719-.719V9.345H4.313a.719.719,0,1,1,0-1.438h.718V7.188a.719.719,0,0,1,1.438,0v.718h.718a.719.719,0,1,1,0,1.438H6.469v.718A.72.72,0,0,1,5.75,10.782Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DocumentPlusIcon extends Vue {}
</script>

<style>
</style>
